import React, { Component } from 'react';
import Config from './Config';
import List from './List';
//import { Scrollbars } from 'react-custom-scrollbars';
import FX from './functions/functions';
//import OrderEdge from './OrderEdge';

class ShippingService extends Component {
  constructor(props) {
    super(props);
    this.state = {services:[]};
  }
  componentDidMount(){
    this.retrieveData();
  }
  retrieveData = (limit) => {
    var data = {customer_id: this.props.root.state.customer_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'shippingService' + qs, (res, i) => {
      this.setState({ services : res.post_services });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  componentWillMount(){
    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    var found = false;
    if(x[1] && parseInt(x[1],10)){
        console.log(parseInt(x[1],10));
        var root_state = this.props.root.state;
        this.props.root.state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            root_state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
     }
      if (x[1] && !found) {
        this.retrieveDetail(parseInt(x[1],10));
        //console.log('/' + x[0]);
        //FX.navigate.bind(this,state.panel, undefined ,'/' + x[0],state,true)();
        //window.location = '/' + x[0];
      }
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    var data = {id: id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_detail' + qs , (res, i) => {
      var detail = this.props.root.setState({detail: res.product});
    });
  }
  addAlias = () => {
    console.log(document.getElementById("alias").value);
    console.log(document.getElementById("equivalent").value);
    if(!document.getElementById("alias").value){
      return alert('Please enter the Shipping Method as it will appear in your API');
    }
    if(!document.getElementById("equivalent").value){
      return alert('Please select the equivalent service.');
    }
    FX.load(this.props.root,'shippingService/createAlias', (res, i) => {
      this.retrieveData();
    (document.getElementById("alias").value = '');
    (document.getElementById("equivalent").value = '');
    }, {method:'POST', data:{ customer_id: this.props.root.state.customer_id ,  alias: document.getElementById("alias").value , equivalent: document.getElementById("equivalent").value}});
  }
  deleteAlias = (service_id) => {
    console.log(document.getElementById("alias").value);
    console.log(document.getElementById("equivalent").value);
    
    FX.load(this.props.root,'shippingService/deleteAlias', (res, i) => {
    (document.getElementById("alias").value = '');
    (document.getElementById("equivalent").value = '');
      this.retrieveData();
    }, {method:'POST', data:{ customer_id: this.props.root.state.customer_id , service_id: service_id }});
  }
  render() {
      console.log(this.state);
      var service_list = this.state.services.filter(serv => {return serv.customer_id != 0}).map((serv) => {
        var equiv;
        this.state.services.some(s => {
           if ( parseInt(s.id,10) === parseInt(serv.equivalent,10)){
              equiv = s;
              return true;
           }
           return false;
        })
        if(!equiv){
          equiv = {name: '-Unknown-'};
        }
          return (
            <div className="service">
                {serv.name} - ({equiv.name})
                <button onClick={this.deleteAlias.bind(this,serv.id)}>Clear</button>
            </div>)
      })
      var service_option = this.state.services.filter(serv => {return serv.customer_id == 0}).map((serv) => {
          return (
            <option value={serv.id}>
                {serv.name}
            </option>)
      });
      var service_select =  (
        <div>
            <label>
              Equivalent:
            </label>
            <select id="equivalent">
                <option value="">
                    ----------------
                </option>)
                {service_option}
            </select>
        </div>
      );
      
      return (
        <div className="ShippingService">
          Shipping Service
          {service_list}
          <div>
            <label>
              Alias:
            </label>
            <input id="alias"/>
          </div>
          {service_select}
          <button className="setUp" onClick={this.addAlias}>Set Up</button>
        </div>
      );
  }
}

export default ShippingService;



// WEBPACK FOOTER //
// ./src/ShippingService.js